import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Star, Crown, Download, Check } from 'lucide-react';
import api from '@/lib/api';
import { formatTL } from '@/lib/format';
import { Card } from '@/components/shared';

export default function AdminRewards() {
  const [sug, setSug] = useState(null);
  const [yb, setYb] = useState(null);

  const load = () => {
    api.get('/admin/ayin-mimari/suggestions').then((r) => setSug(r.data)).catch(() => {});
    api.get('/leaderboard/yearly').then((r) => setYb(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const confirmAotm = async (id) => {
    try { await api.post('/admin/ayin-mimari', { architectId: id }); toast.success('Ayın Mimarı seçildi (VIP verildi)'); load(); }
    catch { toast.error('İşlem başarısız'); }
  };
  const toggleVip = async (id, vip) => {
    try { await api.put(`/admin/architects/${id}`, { vip: !vip }); toast.success(vip ? 'VIP kaldırıldı' : 'VIP verildi'); load(); }
    catch { toast.error('İşlem başarısız'); }
  };
  const flagYearEnd = async () => {
    try { const r = await api.post('/admin/year-end/flag'); toast.success(`${r.data.flagged} mimar yıl sonu için işaretlendi`); load(); }
    catch { toast.error('İşlem başarısız'); }
  };
  const exportCsv = () => {
    if (!yb) return;
    const top10 = yb.rows.slice(0, 10);
    const rows = [['Sıra', 'Mimar', 'Şehir', 'Seviye', 'Yıllık Ciro', 'VIP']];
    top10.forEach((r) => rows.push([r.rank, r.name, r.city, r.tier, r.turnover, r.vip ? 'Evet' : 'Hayır']));
    const esc = (v) => `"${String(v).replace(/"/g, '""')}"`;
    const csv = rows.map((x) => x.map(esc).join(',')).join('\n');
    const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = `yilin-mimarlari-${yb.year}.csv`;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    toast.success('İlk 10 listesi indirildi');
  };

  return (
    <div className="fade-up max-w-4xl" data-testid="admin-rewards">
      <h1 className="font-serif text-3xl text-navy mb-1">Ödüller & Seviye</h1>
      <p className="text-navy/50 text-sm mb-6">Ayın Mimarı seçimi, VIP yönetimi ve yıl sonu ödülleri</p>

      {/* Ayın Mimarı */}
      <Card className="p-5 mb-6" data-testid="aotm-panel">
        <h2 className="font-serif text-lg text-navy mb-1">Ayın Mimarı — {sug?.period}</h2>
        <p className="text-xs text-navy/50 mb-4">Bu ayki ciroya göre sıralı öneriler. Onayla veya değiştir; seçilen VIP statüsü kazanır.</p>
        <div className="space-y-2" data-testid="aotm-suggestions">
          {(sug?.top || []).map((r, i) => (
            <div key={r.architectId} className="flex items-center justify-between bg-cream border border-navy/10 rounded-md p-3">
              <div className="flex items-center gap-3">
                <span className="text-xs text-navy/50 w-5">{i + 1}</span>
                <div>
                  <p className="text-sm text-navy font-medium flex items-center gap-1.5">{r.name} {r.vip && <Star strokeWidth={1.5} className="w-3.5 h-3.5 text-gold" />}</p>
                  <p className="text-xs text-navy/50">{r.city} · {formatTL(r.turnover)}</p>
                </div>
              </div>
              {sug.currentId === r.architectId ? (
                <span className="text-xs px-2.5 py-1 rounded-full bg-gold/15 text-gold flex items-center gap-1"><Crown strokeWidth={1.5} className="w-3.5 h-3.5" /> Seçili</span>
              ) : (
                <button onClick={() => confirmAotm(r.architectId)} data-testid={`confirm-aotm-${r.architectId}`} className="text-xs bg-navy text-cream px-3 py-1.5 rounded-md active:scale-95 transition-transform">Seç</button>
              )}
            </div>
          ))}
        </div>
      </Card>

      {/* Yılın Mimarları */}
      <Card className="p-5" data-testid="year-end-panel">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-serif text-lg text-navy">Yılın Mimarları — {yb?.year}</h2>
          <div className="flex gap-2">
            <button onClick={flagYearEnd} data-testid="flag-year-end" className="text-xs bg-navy text-cream px-3 py-1.5 rounded-md active:scale-95 transition-transform">İlk 10'u İşaretle</button>
            <button onClick={exportCsv} data-testid="export-year-end" className="inline-flex items-center gap-1.5 text-xs border border-navy/20 text-navy px-3 py-1.5 rounded-md active:scale-95 transition-transform"><Download strokeWidth={1.5} className="w-3.5 h-3.5" /> CSV</button>
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm border-collapse">
            <thead><tr className="text-left text-navy/50 text-xs border-b border-navy/10">
              <th className="py-2 pr-4">#</th><th className="py-2 pr-4">Mimar</th><th className="py-2 pr-4">Yıllık ciro</th><th className="py-2 pr-4">VIP</th><th className="py-2 pr-4">Yıl sonu</th>
            </tr></thead>
            <tbody data-testid="year-end-list">
              {(yb?.rows || []).slice(0, 15).map((r) => (
                <tr key={r.architectId} className="border-b border-navy/10">
                  <td className="py-2 pr-4 text-navy/60">{r.rank}</td>
                  <td className="py-2 pr-4 text-navy font-medium">{r.name}</td>
                  <td className="py-2 pr-4 text-navy/70">{formatTL(r.turnover)}</td>
                  <td className="py-2 pr-4">
                    <button onClick={() => toggleVip(r.architectId, r.vip)} data-testid={`vip-toggle-${r.architectId}`}
                      className={`text-xs px-2.5 py-1 rounded-full border ${r.vip ? 'bg-gold/15 text-gold border-gold/30' : 'border-navy/20 text-navy/50'}`}>
                      {r.vip ? <span className="inline-flex items-center gap-1">VIP <Check strokeWidth={2} className="w-3 h-3" /></span> : 'VIP yap'}
                    </button>
                  </td>
                  <td className="py-2 pr-4">{r.yearEnd ? <Crown strokeWidth={1.5} className="w-4 h-4 text-gold" /> : <span className="text-navy/30">—</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-xs text-navy/40 mt-3">VIP'ler Bella Maison sosyal hesaplarında öne çıkarılır ve öncelikli ödeme alır. (Pazarlama ekibi notu)</p>
      </Card>
    </div>
  );
}
